import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { CommonLayoutModule, CommonUIModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';

import { TruckOverviewFilterComponent } from './component/truck-overview-filter.component';

@NgModule({
  declarations: [
    TruckOverviewFilterComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,

    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonLayoutModule,
    CommonTranslationModule,
    CommonUIModule
],
  exports: [
    TruckOverviewFilterComponent
  ]
})
export class TruckOverviewFilterModule { }
